'use strict'

module.exports = {
  BIND_TO_COMPONENT: 'BIND_TO_COMPONENT',
  CURRENT_RECORD_MODIFIED: 'CURRENT_RECORD_MODIFIED',
  RECORD_SET_LOADED: 'RECORD_SET_LOADED',
  CURRENT_VIEW_CHANGED: 'CURRENT_VIEW_CHANGED',
  CURRENT_INDEX_CHANGED: 'CURRENT_INDEX_CHANGED'
}



// WEBPACK FOOTER //
// ./adapters/cmdTypes.js